module.exports = __webpack_public_path__ + "img/gruponc_0.359ad686.png";